import { useQuery } from '@tanstack/react-query';
import { getAgencyLogoSmall } from '../../../../../api/AuthService';

/** The agency's small logo, or null where it has none: the one query both agency headers draw from. */
export function useAgencyLogo(accountId: string | undefined) {
  const { data } = useQuery({
    queryKey: ['account', 'logo', accountId],
    queryFn: () =>
      getAgencyLogoSmall(accountId).then((resp) =>
        resp.status === 200 ? resp.data : null
      ),
    cacheTime: 60 * 10000,
    enabled: Boolean(accountId),
  });
  return (data as string | null | undefined) ?? null;
}
